export const getDecimalPlaces = (n: number | string | undefined): number => {
  if (n === undefined) return 0;

  // Convert the input to string once so we can analyse its format.
  const str = String(n).toLowerCase();

  // --- NEW: Handle scientific notation (e.g. 1e-8, 1.23E-6) ------------------
  // Regex groups:
  //   1) coefficient (can contain decimal point)
  //   2) exponent (with optional sign)
  const sciMatch = str.match(/^([+-]?\d*\.?\d+)[e]([+-]?\d+)$/);
  if (sciMatch) {
    const [, coeff, expStr] = sciMatch;
    const exponent = parseInt(expStr, 10);

    // Split the coefficient to inspect the fractional part (if any)
    const [, coeffFrac = ""] = coeff.split(".");

    if (exponent < 0) {
      // For negative exponents (e.g. 1e-8 -> 0.00000001),
      // the total decimal places equal |exponent| plus any decimals in the coefficient.
      const decimals = Math.abs(exponent) + coeffFrac.length;
      // Keep the original safety limit of 8 decimal places.
      return Math.min(decimals, 8);
    }

    // For positive exponents, the decimal point moves to the right.
    // After the shift, any remaining fractional digits determine the decimal places.
    // Example: 1.23e2 -> 123, 1.23e1 -> 12.3 (1 decimal place left)
    const remainingDecimals = Math.max(0, coeffFrac.length - exponent);
    return Math.min(2, remainingDecimals);
  }
  // ---------------------------------------------------------------------------

  const [integer, frac = ""] = str.split(".");
  if (!frac) return 0; // integer

  // If integer part is not zero, limit to 2 decimal places max
  if (parseInt(integer) !== 0) {
    return Math.min(2, frac.length);
  }

  // If integer part is zero, find 2 significant digits in fractional part
  let nonZeros = 0;
  let index = 0;
  for (const char of frac) {
    if (char !== "0") nonZeros++;
    if (nonZeros === 2) return index + 1; // keep up to here
    index++;
    if (index >= 8) break; // safety check to prevent excessive processing
  }
  // There were fewer than two non-zero digits – keep them all.
  return frac.length;
};
